import { GetServerSideProps } from 'next';
import { ThemeProvider } from 'styled-components';

import Footer from '@/components/footer/FooterWrapper';
import HeaderRefresh from '@/components/homepageRefresh/header/Header';
import Layout from '@/components/layout/LayoutWrapper';
import blogMessages from '@/components/subpages/data/stress/blog';
import breatheBubbleMessages from '@/components/subpages/data/stress/breatheBubble';
import FAQSections from '@/components/subpages/data/stress/faq.mdx';
import heroMessages from '@/components/subpages/data/stress/hero';
import { reviews, messages as reviewsMessages } from '@/components/subpages/data/stress/reviews';
import { sections, messages as toolsMessages } from '@/components/subpages/data/stress/tools';
import unlockMessages from '@/components/subpages/data/stress/unlock';
import { stressTheme } from '@/components/subpages/data/themes';
import SubpageLayout from '@/components/subpages/SubpageLayout';
import { InitRequest } from '@/hooks/store';
import { getInitialServerState } from '@/utils/pageGeneration/getServerSideProps';

const StressAnxietySubpage = () => {
	return (
		<Layout
			customSeo={{
				title: 'Meditation to Relieve Stress & Anxiety - Calm',
				primaryDescription:
					"Learn how to relieve stress and handle anxiety with Calm's personalized resources. Join the millions leveraging our meditations, music, and daily wisdom to better navigate life's stressors.",
			}}
			pageName="stress-anxiety"
		>
			<ThemeProvider theme={stressTheme}>
				<HeaderRefresh isOpaque />
				<SubpageLayout
					heroHeading={heroMessages.heading}
					heroBody={heroMessages.body}
					heroCta={heroMessages.cta}
					heroBgImage="/_n/images/subpages/stress-hero.webp"
					mediaSectionType="bubble"
					mediaSectionHeading={breatheBubbleMessages.heading}
					unlockHeading={unlockMessages.heading}
					unlockBody={unlockMessages.body}
					unlockBgImage="/_n/images/subpages/stress-collage.webp"
					plansBgImage="/_n/images/subpages/stress-plans.webp"
					reviews={reviews}
					reviewsHeading={reviewsMessages.reviewsHeading}
					blogHeading={blogMessages.heading}
					blogCategory="stress-anxiety"
					toolsSections={sections}
					toolsHeading={toolsMessages.heading}
					FaqSections={FAQSections}
				/>
			</ThemeProvider>
			<Footer />
		</Layout>
	);
};

export const getServerSideProps: GetServerSideProps = async context => {
	const initialState = await getInitialServerState(
		context,
		[InitRequest.DEVICE, InitRequest.USER, InitRequest.PRICES],
		undefined,
		undefined,
		true,
	);

	return {
		props: {
			initialState,
		},
	};
};

export default StressAnxietySubpage;
